import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/home/clothoff/www/apps/web/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/clothoff/www/apps/web/components/header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Wrapper","Main"] */ "/home/clothoff/www/node_modules/@cloai/uikit/build/index.js");
